import { Dropdown } from '@statsbomb/kitbag-components';
import { CompetitionSelector } from '@statsbomb/kitbag-global-football';
import { useAtomValue } from 'jotai';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { defaultCompetitionIdAtom } from '@/atoms/filters/highLevel/competitions';
import { genderAtom } from '@/atoms/queries/userConfigs';
import { noop } from '@/utils/noop';

const Fallback = () => {
  const { t } = useTranslation('entity');

  return (
    <Dropdown
      id="user-competition-select-fallback"
      label={t('competition')}
      placeholder=""
      isLoading
      isMulti={false}
      onChange={noop}
    />
  );
};

type UserCompetitionSelectProps = { showTracking?: boolean };

const UserCompetitionSelectWithData = ({ showTracking }: UserCompetitionSelectProps) => {
  const defaultCompetitionId = useAtomValue(defaultCompetitionIdAtom);
  const gender = useAtomValue(genderAtom);

  return (
    <CompetitionSelector
      scope={CompetitionSelector.Scope.User}
      gender={gender}
      isMulti={false}
      preferredCompetitionId={defaultCompetitionId ?? undefined}
      showTracking={showTracking}
    />
  );
};

export const UserCompetitionSelect = ({ showTracking }: UserCompetitionSelectProps) => (
  <Suspense fallback={<Fallback />}>
    <UserCompetitionSelectWithData showTracking={showTracking} />
  </Suspense>
);
